import api from "./axiosInstance";

const apiRequestFunction = (token) => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/filter`, {
        headers: {
           // Security Headers
          'X-XSS-Protection': '1; mode=block',
          Authorization: `Bearer ${token}`,
          'X-Content-Type-Options': 'nosniff',
          'X-Frame-Options': 'DENY',
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Permissions-Policy': 'camera=(), microphone=(), geolocation=()',
          
          // Standard Headers
          "Content-Type": "application/json",
        
        },
        // params: {
        //   page: navigationCount,
        // },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default apiRequestFunction;
